module.exports = __webpack_public_path__ + "static/media/powered-by-DQ_icon.b4180095.png";